<!-- whether this can be visible-->
@if (showComponent) {

  <!-- show clickable pay buttons:-->
  @if (displayPayButton) {

      <!-- show states: No transaction started-->
      @if (!request.taxPaymentStatus || request.taxPaymentStatus ==='' || request.taxPaymentStatus === null) {
      <button class="btn btn-sm btn-primary order-3 order-sm-3 order-md-3 order-lg-3 order-xl-3" type="button"
        (click)="pay()"><span translate="Button.Pay" class="me-1"></span>€ {{ request.taxAmount }}<img
          src="../../../../assets/iDEAL-Wero-logo.png" class="wero-logo ms-2"></button>
      }
      <!-- show states: Failed/Rejected-->
      @if (request.taxPaymentStatus ==='RJCT') {
      <button class="btn btn-sm btn-primary order-3 order-sm-3 order-md-3 order-lg-3 order-xl-3" type="button"
        (click)="pay()"><span translate="Button.RetryPayment"></span> <span
          class="ms-2 badge badge-small rounded-pill bg-danger" translate="Button.PaymentFailed"></span></button>
      }
  }

  <!-- show states: Payed-->
  @if (request.taxPaymentStatus ==='ACSC') {
  <button class="btn btn-sm btn-primary order-3 order-sm-3 order-md-3 order-lg-3 order-xl-3" type="button" disabled>€ {{
    request.taxAmount }} <span class="badge badge-small rounded-pill bg-success"
      translate="Button.PaymentPayed"></span></button>
  }

  <!-- show states: Pending-->
  @if (request.taxPaymentStatus ==='PDNG') {
  <button class="btn btn-sm btn-primary" type="button" disabled><span role="status"
      translate="Button.PaymentProcessing"></span><span class="ms-2 spinner-border spinner-border-sm wero-logo"
      aria-hidden="true"></span></button>
  }

}
